<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Open VPN Server
              <router-link
                :to="{ name: 'OpenVPNServerAdd' }"
                class="btn ml-auto"
                v-if="actionCreate == false"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Open VPN Server</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form v-if="1 == 0" @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!-- Audra Name -->
                  <div v-if="organizationId == 1" class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname">Audra</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.accountId"
                          :options="Object.keys(pre.audraName)"
                          :custom-label="(opt) => pre.audraName[opt]"
                          placeholder="Select Audra Name"
                          :searchable="true"
                          :multiple="false"
                          id="accountId"
                          v-bind:class="{
                            'has-error': errors.has('accountId'),
                          }"
                          name="accountId"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- Pool -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="vpn_pool">Pool</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="vpn_pool"
                          name="vpn_pool"
                          v-model="filter.vpn_pool"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Pool"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Server -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="vpn_server">Server</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="vpn_server"
                          name="vpn_server"
                          v-model="filter.vpn_server"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Server"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- VPN Port -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="vpn_port">VPN Port</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="vpn_port"
                          name="vpn_port"
                          v-model="filter.vpn_port"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="VPN Port"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- FW Port -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="fw_port">FW Port</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="fw_port"
                          name="fw_port"
                          v-model="filter.fw_port"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="FW Port"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row justify-content-end">
                    <div class="col-md-9">
                      <button type="submit" class="btn mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-outline" @click="resetFilter()">
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body p-4 p-md--5">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <div class="row">
                <div class="col-md-7">
                  <div class="server-list">
                    <ul v-for="val in list.data" :key="val.id">
                      <li v-if="organizationId == 1">
                        Device Name
                        <strong>{{ val.device_name }}</strong>
                      </li>
                      <li>
                        Server Name<strong>{{ val.vpn_server_name }}</strong>
                      </li>
                      <li>
                        Type<strong>{{
                          val.vpn_type == 0 ? "User Password" : "Certificate"
                        }}</strong>
                      </li>
                      <li>
                        Server<strong>{{ val.vpn_server }}</strong>
                      </li>

                      <li>
                        Pool<strong>{{ val.vpn_pool }}</strong>
                      </li>

                      <li>
                        Port<strong>{{ val.vpn_port }}</strong>
                      </li>
                      <li v-if="val.vpn_type == 0">
                        Split Tunnel<strong>{{
                          val.split_tunnel == 0 ? "No" : "Yes"
                        }}</strong>
                      </li>
                      <li>
                        <router-link
                          v-if="val.vpn_type == 0"
                          :to="{
                            name: 'OpenVPNServerEdit',
                            params: { id: val.id },
                          }"
                          class="btn mr-2"
                        >
                          <i class="icon-edit mr-2"></i>
                          <span class="d-none d-sm-inline-flex">Edit</span>
                        </router-link>

                        <a
                          v-if="val.vpn_type == 0"
                          title="Regenerate"
                          class="btn mr-2"
                          href="javascript:void(0)"
                          @click="regenerate(val.id, val.accountId, val.vpn_server_name)"
                          ><i class="icon-refresh mr-2"></i>
                          <span class="d-none d-sm-inline-flex">Regenerate</span></a
                        >
                        <a
                          v-if="val.vpn_type == 0"
                          title="Download"
                          class="btn btn-outline mr-2"
                          href="javascript:void(0)"
                          @click="
                            downloadServer(val.accountId, val.vpn_server_name, val.id)
                          "
                          ><i class="icon-download mr-md-2"></i
                          ><span class="d-none d-sm-inline-flex">Download</span></a
                        >
                        <a
                          v-if="actionDelete == true || checkDeletePermission(val)"
                          class="btn btn-danger"
                          href="javascript:void(0)"
                          @click="
                            deleteObject(val.id, val.accountId, index, val.vpn_type)
                          "
                          ><i class="icon-trash mr-md-2"></i
                          ><span :class="{ 'd-none d-sm-inline-flex': val.vpn_type == 0 }"
                            >Delete</span
                          ></a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
const fileDownload = require("js-file-download");

export default {
  name: "OpenVPNServer",
  metaInfo: {
    title: "Open VPN Server | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: true,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      audraName: {},
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/open_vpn_servers";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      await CommonAPI.getCustomPermission(
        "/get-custom-permission-infos?path=api/open_vpn_servers"
      ).then((response) => {
        if (response.status == 200) {
          this.custom_permission_data = response.data;
        }
      });

      if (!_.isEmpty(this.custom_permission_data)) {
        // this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
        //   this.custom_permission_data.action_permission,
        //   this.custom_permission_data["create_id_condition"],
        //   this.user_detail,
        //   this.custom_permission_data.enableAdministratorPermissionByDefault
        // );
        // this.actionCreate = true;
      }

      await this.getList()
        .then((response) => {
          this.list = response.data;
          if (this.list.total > 0) {
            this.actionCreate = true;
          } else {
            this.actionCreate = false;
          }
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    deleteObject: function (id, accountId, index, vpnType) {
      const _this = this;
      let text = "";
      if (vpnType == 0)
        text = "The client associated with this server will also be deleted.";
      const delete_api_url = "/open_vpn_servers/" + id;
      _this.$swal
        .fire({
          title: "Are you sure?",
          html: "You won't be able to revert this!<br>" + text,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url, {
                params: {
                  accountId: accountId,
                  vpnType: vpnType,
                },
              })
              .then((response) => {
                _this.list.data.splice(index, 1);
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
                this.actionCreate = false;
              })
              .catch((errors) => {
                _this.is_loading = false;
                // _this.$swal.fire(
                //   error.response.data.errors.message
                // )
                if (errors.response.status === 501) {
                  _this.$toaster.error(errors.response.data.errors.message);
                } else if (errors.response.data) {
                  _this.$toaster.error(errors.response.data.message);
                }
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },

    downloadServer: function (accountId, vpn_server_name, id) {
      const _this = this;
      const download_api_url =
        "/downloadServer/" + accountId + "_" + vpn_server_name + ".ovpn";

      _this.is_loading = true;
      axios
        .get(download_api_url, {
          params: {
            accountId: accountId,
            id: id,
          },
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, vpn_server_name + ".ovpn");
          _this.$toaster.success("Downloaded Successfully");
          _this.is_loading = false;
        })
        .catch((error) => {
          _this.is_loading = false;
          if (error.response.status === 501) {
            error.response.data.text().then((text) => {
              const textErrors = JSON.parse(text);
              _this.$toaster.warning(textErrors.errors.message);
            });
          } else if (error.response.data) {
            _this.$toaster.error(error.response.data.message);
          }
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },

    regenerate: function (id, accountId, vpn_server_name) {
      const _this = this;
      const regenerate_api_url =
        "/regenerate/" + id + "/" + accountId + "/" + vpn_server_name;

      _this.is_loading = true;
      axios
        .get(regenerate_api_url)
        .then((response) => {
          _this.$toaster.success("Regenerated Successfully");
          _this.is_loading = false;
        })
        .catch((error) => {
          _this.is_loading = false;
          if (error.response.status === 501) {
            _this.$toaster.error(error.response.data.errors.message);
          } else if (error.response.data) {
            _this.$toaster.error(error.response.data.message);
          }
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },
    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/open-vpn-servers-export", {
          params: { userAccountId: LocalStorage.get("accountId") },
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "open_vpn_servers.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },
    selectedRowAll: function () {
      const isSelectedAll = (this.is_selected_all = !this.is_selected_all);
      if (isSelectedAll) {
        var items = [];
        this.list.data.forEach(function (item) {
          items.push({ id: item.id, accountId: item.accountId });
        });
        this.selected_row = items;
      } else {
        this.selected_row = [];
      }
    },
    handleSelectedRows(command) {
      if (command === "delete") {
        axios({
          method: "delete",
          url: "/open_vpn_servers/delete-all",
          data: { ids: this.selected_row },
          headers: { "Content-Type": "application/json" },
        })
          .then(function (response) {
            Notification.success({
              title: "Deleted Successfully",
              message: "Data deleted successfully",
              type: "success",
            });
            this.initialize();
          })
          .catch((errors) => {
            if (!_.isEmpty(errors.response) && errors.response.status === 500) {
              this.$toaster.error(errors.response.data.message);
            }
          })
          .finally(() => {
            this.is_selected_all = false;
            this.initialize();
          });
      }
    },
  },
};
</script>
